/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { TextAreaField, FormFieldProps } from '@nintendo/forms';
import Tooltip from '@nintendo/forms/lib/js/components/common/Tooltip';

interface TextCountedFieldProps extends FormFieldProps {
    textAreaProps?: React.DetailedHTMLProps<
        React.TextareaHTMLAttributes<HTMLTextAreaElement>,
        HTMLTextAreaElement
    >;
    length: number;
    maxLength: number;
}

const TextCountedField = (props: TextCountedFieldProps) => {
    const { label, name, isRequired, length, maxLength } = props;

    return (
        <>
            <div className="form-group row">
                <label htmlFor={name} className="col-sm-5 control-label">
                    {isRequired && <span className="text-danger">* </span>}
                    {label} &nbsp;
                    <Tooltip text={props.tooltip} name={props.name} />
                </label>
                <div className="col-sm-7 text-right">
                    <small>
                        {length} characters (of {maxLength})
                    </small>
                </div>
            </div>

            <TextAreaField {...props} labelCssClass="d-none" contentCssClass="col-sm-12" />
        </>
    );
};

export default TextCountedField;
